






import Vue from "vue";
import TestCaseStatus from "@/core/TestCaseStatus";

export default Vue.extend({
  props: {
    testCase: {
      type: Object,
      required: true
    }
  },
  computed: {
    statuses(): any {
      let status = new TestCaseStatus(
        this.testCase.steps.map((s: any) => s.status || "pending")
      );
      return status.value;
    }
  }
});
